export const normalizeSearchQuery = (query: string | null | undefined) => (query ?? '').replace(/\s+/g, ' ').trim();

const normalizeSearchText = (value: unknown) =>
  value === null || value === undefined ? '' : normalizeSearchQuery(String(value)).toLowerCase();

export const getSearchTerms = (query: string | null | undefined) =>
  normalizeSearchText(query).split(' ').filter(Boolean);

export const matchesSearchTerms = (terms: string[], values: unknown[]) => {
  if (!terms.length) return true;
  const texts = values.map(normalizeSearchText).filter(Boolean);
  return terms.every((term) => texts.some((text) => text.includes(term)));
};

export const matchesSearch = (query: string | null | undefined, values: unknown[]) =>
  matchesSearchTerms(getSearchTerms(query), values);
